/* Beloved & Bespoke – collapse the Infinite Options add-on list into one tidy "Add a little extra" row */
(function () {
  function label(details) {
    var n = details.querySelectorAll('#infiniteoptions-container input[type=checkbox]:checked').length;
    var c = details.querySelector('.bb-addons__count');
    if (c) c.textContent = n ? ' (' + n + ' added)' : '';
  }
  function wrap() {
    var c = document.getElementById('infiniteoptions-container');
    if (!c || c.closest('details.bb-addons') || !c.querySelector('input[type=checkbox]')) return;
    var d = document.createElement('details');
    d.className = 'bb-addons';
    d.innerHTML = '<summary>Add a little extra <span class="bb-addons__count"></span><br><small style="font-weight:400">Wine, candles, mugs, blankets &amp; more</small></summary>';
    c.parentNode.insertBefore(d, c);
    d.appendChild(c);
    d.addEventListener('change', function () { label(d); });
    label(d);
  }
  var mo = new MutationObserver(wrap);
  mo.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', wrap);
})();
